function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23",
  height: "23",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  fill: "#E9434A",
  cx: "11.5",
  cy: "11.5",
  r: "10.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.34 16.907l4.16-4.16 4.16 4.16a.735.735 0 001.04 0l.207-.208a.735.735 0 000-1.04l-4.16-4.159 4.16-4.16a.735.735 0 000-1.04l-.208-.207a.735.735 0 00-1.04 0l-4.159 4.16-4.16-4.16a.735.735 0 00-1.04 0l-.207.208a.735.735 0 000 1.04l4.16 4.159-4.16 4.16a.735.735 0 000 1.04l.208.207a.735.735 0 001.04 0z",
  fill: "#FFF"
}))));